import { normalizeStayCriteria } from '@travelata-libs/travelata-frontend';
import Backbone from 'backbone';
import { format, parseISO } from 'date-fns';
import abTests from '@/js/common/Domain/Service/abTests';

const ISO_DAY = 'yyyy-MM-dd';
const STAY_CALENDAR_AB_TEST = 'IN-5001';

// Страницы либы проверяют ту же группу сами: abTests приходят в конфиг initLibrary (на SSR — из PHP).
export function isStayCalendarEnabled(): boolean {
    return abTests.hasTest(STAY_CALENDAR_AB_TEST);
}

// Поиск на выдаче и отельной запускает Backbone по своей модели, а не форма либы: без приведения
// поле покажет 7 ночей, а в поиск уйдёт диапазон 7–10 из ссылки или дефолтов.
export function applyStayCriteria(searchFormModel: Backbone.Model): void {
    const dates = searchFormModel.get('checkInDateRange').get('model');
    const nights = searchFormModel.get('nightRange').get('model');
    if (!dates || !nights) {
        return;
    }

    const normalized = normalizeStayCriteria({
        dateRange: {
            from: format(dates.get('from'), ISO_DAY),
            to: format(dates.get('to'), ISO_DAY),
            daysFlexible: dates.get('daysFlexible') || 0,
        },
        nights: { from: nights.get('from'), to: nights.get('to') },
    });

    searchFormModel.get('checkInDateRange').set('model', new Backbone.Model({
        from: parseISO(normalized.dateRange.from),
        to: parseISO(normalized.dateRange.to),
        daysFlexible: normalized.dateRange.daysFlexible,
    }));
    searchFormModel.get('nightRange').set('model', new Backbone.Model(normalized.nights));
}
